import type { IconProps } from "@radix-ui/react-icons/dist/types";
import { useState } from "react";
import { MdCheckCircleOutline, MdContentCopy } from "react-icons/md";
import { twMerge } from "tailwind-merge";

import { Button } from "./ui/button";

export const Clipboard = (props: IconProps & { content: string }) => {
  const [isCopied, setIsCopied] = useState(false);
  const handleCopy = () => {
    navigator.clipboard.writeText(props.content);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 2000);
  };
  return (
    <Button
      className={twMerge(
        "text-primary hover:text-primary relative",
        props.className,
      )}
      onClick={handleCopy}
      variant={"ghost"}
      size={"icon"}
    >
      <MdContentCopy
        {...props}
        className={twMerge(
          "absolute inset-0 h-full w-full duration-200",
          isCopied ? "opacity-0" : "opacity-100",
        )}
      />
      <MdCheckCircleOutline
        {...props}
        className={twMerge(
          "absolute inset-0 h-full w-full duration-200",
          isCopied ? "opacity-100" : "opacity-0",
        )}
      />
    </Button>
  );
};
